import icons from './icons.js';
import roles from './roles.js';

export default class utils {
  constructor(vue) {
    this.icons = icons;
    this.vue = vue;
    Object.keys(this.icons).forEach((name, index) => vue.component(name, Object.values(this.icons)[index]));
    return this;
  }

  choosePictureName(clientName) {
    const str = clientName.split(' ');
    if (!str[1]) return str[0][0] + str[0][1];
    else return str[0][0] + str[1][1];
  }

  splitStringBySegmentLength = str => new Intl.NumberFormat('fr-FR').format(str);
  sirenFormat = siren => siren.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  formatDate = time => new Date(time).toLocaleDateString('fr-FR');
  roles = roles;
  isInViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  mobilecheck = function detectMob() {
    return (
      (window.outerWidth < 400 && window.outerHeight < 900) ||
      [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i].some(toMatchItem => navigator.userAgent.match(toMatchItem))
    );
  };
}
